import { empty, strval, in_array, phpCopy } from '../../php-compat';
import type { PortEnv } from '../../port-contract';
import { at, values, num, f, list, record } from './support-b2';
export interface Deps {
    pos_coord(row: unknown, key: string): unknown;
    inventory_field(row: unknown, key: string): unknown;
    item_field(row: unknown, key: string): unknown;
    ft_inventory_transform_3d(row: unknown): unknown;
    ft_ground_occupancy_base_size(row: unknown, definition: unknown): unknown;
    inventory_is_passage_prop(row: unknown): boolean;
}
/** PHP: ft_ground_occupancy_z_span (includes/functions/janus/encounter/ft_ground_occupancy.php:112) */
export function ftGroundOccupancyZSpan(row: unknown, height: number, z: unknown = null, support = false, env: PortEnv<Deps>): unknown { const n = num(z ?? env.deps.pos_coord(row, 'z_pos') ?? 0); return list(support ? [f(n), f(n + num(height))] : [f(n - num(height) / 2), f(n + num(height) / 2)]); }
/** PHP: ft_ground_tree_trunk_diameter_ft (includes/functions/janus/encounter/ft_ground_occupancy.php:153) */
export function ftGroundTreeTrunkDiameterFt(row: unknown, definition: unknown = null, env: PortEnv<Deps>): unknown {
    const d = env.deps;
    if (typeof d.inventory_field(row, 'inventory_id') !== 'string')
        return null;
    const type = strval(d.item_field(row, 'item_type') ?? (definition !== null ? d.item_field(definition, 'item_type') : '') ?? '');
    if (type !== 'tree')
        return null;
    const t = d.ft_inventory_transform_3d(row);
    let scale = num(at(t, 'scale') ?? 1);
    if (!Number.isFinite(scale) || scale <= 0)
        scale = 1;
    return f(Math.min(4, Math.max(1, num(d.ft_ground_occupancy_base_size(row, definition)) * scale * .16)));
}
/** PHP: ft_ground_occupancy_open_plane (includes/functions/janus/encounter/ft_ground_occupancy.php:1637) */
export function ftGroundOccupancyOpenPlane(env: PortEnv): unknown {
    const key = 'ft_ground_occupancy_open_plane::$plane';
    env.functionStatics[key] ??= record({ v: 1, unit: 'ft', boxes: list([record({ id: 'unshaped', x: record({ min: f(-1e6), max: f(1e6) }), y: record({ min: f(-1e6), max: f(1e6) }), floor: f(0), ceiling: f(1e6) })]), openings: list([]) });
    return phpCopy(env.functionStatics[key]);
}
/** PHP: ft_inventory_is_ground_loot (includes/functions/janus/encounter/ft_ground_occupancy.php:484) */
export function ftInventoryIsGroundLoot(row: unknown, env: PortEnv<Deps>): boolean {
    const d = env.deps;
    if (d.inventory_is_passage_prop(row))
        return false;
    if (!empty(d.item_field(row, 'equipment_slot')))
        return true;
    if (num(d.inventory_field(row, 'inventory_quantity') ?? 0) > 1)
        return true;
    return in_array(strval(d.item_field(row, 'item_type') ?? ''), ['weapon', 'natural_weapon', 'armor', 'shield', 'ammunition', 'consumable', 'potion', 'scroll', 'wand', 'ring', 'currency', 'gem', 'trade_good', 'tool', 'instrument', 'clothing', 'jewelry', 'book', 'component'], true);
}
/** PHP: ft_ground_shape_has_exterior_open (includes/functions/janus/encounter/ft_ground_occupancy.php:753) */
export function ftGroundShapeHasExteriorOpen(shape: unknown): boolean { return values(at(shape, 'boxes')).some(b => at(b, 'creation', 'enclosure') === 'none' || at(b, 'creation', 'environment') === 'exterior-open' || at(b, 'creation', 'presetId') === 'exterior-open'); }
/** PHP: ft_placement_blocked_message (includes/functions/janus/encounter/ft_ground_occupancy.php:849) */
export function ftPlacementBlockedMessage(reason: string): string { return ({ occupied: 'Something is already standing there.', outside_union: 'That spot is outside the map.', no_headroom: 'There is not enough headroom there.', no_clearance: 'There is not enough room there for a creature that size.', wedged: 'There is no clear space to stand near there.', no_footprint: 'That token has no position to move.' } as Record<string, string>)[reason] ?? 'You cannot stop there.'; }
